import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20atmosphere%20with%20warm%20crimson%20and%20amber%20light%20rays%20piercing%20through%20fog%2C%20mysterious%20and%20investigative%20mood%2C%20abstract%20geometric%20patterns%2C%20professional%20newsroom%20aesthetic%2C%20deep%20shadows%20with%20warm%20highlights%2C%20cinematic%20composition%2C%20texture%20and%20depth&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="51cg黑料深度揭秘"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      <div className="relative z-10 w-full px-4 md:px-8 text-center">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 mb-6 text-xs font-medium tracking-wider uppercase rounded-full bg-accent-500/20 text-accent-300 border border-accent-500/30 backdrop-blur-sm">
            真相永不沉默
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6 font-heading">
            51cg黑料
            <span className="block text-accent-400">深度揭秘与真相解析</span>
          </h1>
          <p className="text-base md:text-lg text-background-50/75 max-w-2xl mx-auto mb-8 leading-relaxed">
            汇聚51cg黑料最新爆料、用户反馈与深度分析，帮助你全面了解相关平台的真实情况，避免踩坑，做出明智决策。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/zuixin-baoliao"
              className="px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
            >
              查看最新爆料
            </Link>
            <Link
              to="/category/fengxian-tishi"
              className="px-8 py-3.5 text-sm font-semibold bg-background-50/10 text-background-50 rounded-lg hover:bg-background-50/20 backdrop-blur-sm transition-all cursor-pointer whitespace-nowrap border border-background-50/20"
            >
              了解风险提示
            </Link>
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-3 text-background-50/50 text-xs">
          <span>滚动探索</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}